<template>
  <!-- 附件下载工具 -->
  <div class="tool">
    <template v-for="(item, idx) in file_tools">
      <div :key="idx">
        <!-- 手动上传 -->
        <el-button
          style="margin-left: 10px"
          v-if="item.type === 'upload'"
          :key="item.name + idx"
          :type="activeTool === item.type ? 'primary' : ''"
          :disabled="!(userInfo.rootty || ty == '0')"
          :title="item.name"
          @click="toolsClick(item.type)"
          >{{ item.name }}</el-button
        >
        <!-- 批量上传附件 -->
        <el-button
          style="margin-left: 10px"
          v-else-if="item.type == 'batchImport' && item.name"
          :key="item.name + idx"
          :type="'primary'"
          :disabled="!(userInfo.rootty || ty == '0')"
          :title="item.name"
          @click="toolsClick(item.type)"
        >
          {{ item.name }}
        </el-button>
        <!-- 其他 -->
        <el-button
          style="margin-left: 10px"
          v-else-if="item.name"
          :key="item.name + idx"
          :type="
            activeTool === item.type || item.type === 'photo' ? 'primary' : ''
          "
          :disabled="
            !(
              userInfo.rootty ||
              ty == '0' ||
              item.type === 'show' ||
              item.type === 'download'
            )
          "
          :title="item.name"
          @click="toolsClick(item.type)"
        >
          {{ item.name }}
        </el-button>
      </div>
    </template>
    <!-- 批量导入附件 -->
    <BatchImportAtfile
      ref="batchImportAtfile"
      :choos="choos"
    ></BatchImportAtfile>
    <!-- 手动上传 -->
    <ManualUpload
      ref="manualUpload"
      @getappendix="getappendix"
      :title="this.choos.name"
      :b4close="afterManualUpload"
    ></ManualUpload>
    <!-- 拍照 -->
    <camera ref="camera" @refreshDataList="refreshDataList" />
  </div>
</template>

<script>
import BatchImportAtfile from '@components/batchImportAtfile.vue'
import ManualUpload from '@components/manualUpload.vue'
import camera from '@components/common/camera'
import { upLoadCustomFile, DeleteLocalFile } from '@api/api.js'
import { createGguid } from '@/assets/js/pubMethods'
export default {
  components: { BatchImportAtfile, ManualUpload, camera },
  props: {
    pautoid: {
      // 传入的autoid
      type: String,
      default: ''
    },
    choos: {
      // 选中的附件类型
      type: Object,
      default: () => {}
    },
    ty: {
      // 是否通用模板
      type: [Number, String],
      default: '1'
    },
    fileselectData: {
      // 所选附件
      type: Array,
      default: [{}]
    },
    par: {
      // 当前是否父组件
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      userInfo: JSON.parse(sessionStorage.userInfo) || {}, // 用户登录信息
      name: this.$route.query.name,
      autoid: this.$route.query.autoid,
      activeTool: '', // 选中的工具
      file_tools: [
        // {
        //   type: 'batchImport',
        //   name: '批量导入附件',
        //   icon: 'takephoto',
        //   hasRight: true, // 先默认写死
        //   readonlycan: false
        // },
        {
          type: 'photo',
          name: '拍照上传',
          icon: 'takephoto',
          hasRight: true, // 先默认写死
          readonlycan: false
        },
        {
          type: 'upload',
          name: '手动上传',
          icon: 'm201btn08',
          hasRight: true,
          readonlycan: false
        },
        {
          type: 'delete',
          name: '删除附件',
          icon: 'imgdel',
          hasRight: true,
          readonlycan: false
        },
        {
          type: 'show',
          name: '查看附件',
          icon: 'm201btn10',
          hasRight: true, // 先默认写死
          readonlycan: true
        },
        {
          type: 'download',
          name: '下载附件',
          icon: 'm201btn07',
          hasRight: true,
          readonlycan: true
        }
      ],
      systemTipsShow: false,
      errorMsg: ''
    }
  },
  methods: {
    toolsClick(type) {
      if (!this.choos.name) {
        this.$message.warning('请选择要文件类型')
        return
      }
      this.activeTool = type
      switch (this.activeTool) {
        // 批量导入附件
        case 'batchImport': {
          this.$refs.batchImportAtfile.show = true
          this.$refs.batchImportAtfile.fileList = []
          break
        }
        // 拍照上传
        case 'photo': {
          this.$refs.camera.show = true
          break
        }
        // 手动上传
        case 'upload': {
          this.$refs.manualUpload.show = true
          break
        }
        // 删除附件
        case 'delete': {
          if (this.par) {
            this.$emit('showList')
            return
          }
          if (this.fileselectData.length > 0) {
            this.$confirm('确定要删除所选附件吗？', '系统提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            })
              .then(() => {
                DeleteLocalFile({
                  id: this.fileselectData[0].id
                })
                  .then(res => {
                    this.getappendix() // 刷新列表数据
                    this.fileselectData = [] // 既然删除了就清除吧
                    this.$message({
                      type: 'success',
                      message: '文件删除成功'
                    })
                  })
                  .finally(() => {
                    this.activeTool = null // 最后要清除选中的工具按钮
                    // done();
                  })
              })
              .catch(() => {})
          } else {
            this.$message.warning('请选择要删除的文件')
          }
          break
        }
        // 查看附件
        case 'show': {
          if (this.par) {
            this.$emit('showList')
            return
          }
          if (this.fileselectData.length > 0) {
            this.$confirm('您确定要查看所选择的附件吗？', '系统提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            })
              .then(() => {
                window.open(
                  this.fileselectData[0].imgurl +
                    '?v=' +
                    Date.parse(new Date()),
                  '_blank'
                )
              })
              .catch(() => {})
          } else {
            this.$message.warning('请选择要查看的附件！')
          }
          break
        }
        // 下载附件
        case 'download': {
          if (this.par) {
            this.$emit('showList')
            return
          }
          if (this.fileselectData.length > 0) {
            this.$confirm('您确定要下载所选择的附件吗？', '系统提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            })
              .then(() => {
                this.downloadUrlFile(
                  this.fileselectData[0].imgurl,
                  this.fileselectData[0].sfilename +
                    this.fileselectData[0].fileext
                )
              })
              .catch(() => {})
          } else {
            this.$message.warning('请选择要下载的附件！')
          }
          break
        }
      }
    },
    downloadUrlFile(url, fileName) {
      console.log(url, fileName)

      url = url.replace(/\\/g, '/')
      const xhr = new XMLHttpRequest()
      xhr.open('GET', url, true)
      xhr.responseType = 'blob'
      //xhr.setRequestHeader('Authorization', 'Basic a2VybWl0Omtlcm1pdA==');
      xhr.onload = () => {
        if (xhr.status === 200) {
          // 获取文件blob数据并保存
          this.saveAs(xhr.response, fileName)
        }
      }

      xhr.send()
    },
    saveAs(data, name) {
      var urlObject = window.URL || window.webkitURL || window
      var export_blob = new Blob([data])
      var save_link = document.createElementNS(
        'http://www.w3.org/1999/xhtml',
        'a'
      )
      save_link.href = urlObject.createObjectURL(export_blob)
      save_link.download = name
      save_link.click()
    },
    // 手动上传弹窗回调事件
    async afterManualUpload(fileList, pctype, keepOriginalName) {
      // keepOriginalName // 保留原文件名
      let errorData = []
      let hasImp = 0
      let fuckLength = fileList.length

      if (fileList.length > 0) {
        for (const file of fileList) {
          // 保留文件名
          let obj = {
            autoid: this.pautoid || this.autoid,
            username: this.userInfo.name,
            cusfilename: createGguid(),
            packagetype: this.choos.name,
            file: file.raw,
            ty: this.ty
          }
          if (keepOriginalName) {
            obj.cusfilename = file.name.substring(0, file.name.lastIndexOf('.'))
          }
          await upLoadCustomFile(obj).then(res => {
            if (res == 'OK') {
            } else {
              errorData.push({ res: file.name + '_' + res })
            }
            hasImp = hasImp + 1
            this.$refs.manualUpload.percentage = parseInt(
              (hasImp / fuckLength) * 100
            )
            if (hasImp == fuckLength) {
              // 刷新列表
              this.$emit('GetFile')
              if (errorData.length == 0) {
                this.$message.success('导入成功')
              }
              setTimeout(() => {
                this.$refs.manualUpload.show = false
              }, 200)
              this.activeTool = '' // 清除按钮激活状态
              // 清空
              if (errorData.length > 0) {
                this.writeSysTips(errorData)
              }
            }
          })
        }
      }
    },
    // 拍照上传
    refreshDataList(file) {
      this.afterManualUpload([file], this.choos.name, false)
    },
    getappendix() {
      this.$emit('GetFile')
    },
    // 写入系统提示语
    writeSysTips(data) {
      this.systemTipsShow = true
      //this.errorMsg += item.res + '\n'
      switch (typeof data) {
        case 'string':
          this.errorMsg += data + '\n'
          break
        case 'object':
          if (Array.isArray(data)) {
            data.forEach(e => {
              this.writeSysTips(e)
            })
          } else this.errorMsg += data.res + '\n'
          break
        default:
          break
      }
    }
  }
}
</script>

<style scoped lang="scss">
.tool {
  margin: 10px 0;
  display: flex;
  height: 70px;
  align-items: center;
  .el-button--default {
    color: var(--formFontcolor);
  }
}
</style>
